// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"6d13c77a","983":"56617188"}[chunkId] + ".chunk.js";
};